"use client";
import cn from "clsx";
import { AuthList, DataListParams } from "@/components/layout/layoutType";
import { checkDebug, Debug } from "@/util/debug";
import { commonChangeDataId } from "@/util/fetchutil";
import { Container, Flex } from "@radix-ui/themes";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { getColsGroups } from "../../input/inputFunction";
import { mergeArr } from "@/util/arrayutil";
import { getCodeGroups } from "@/util/code";
import Data from "@/components/layout/data/data";
import List from "@/components/layout/data/list/list";
import { DataCols, DataColumn } from "../../input/inputType";
import Head from "next/head";
import { appAppleId, appScheme, checkAndroidWeb, checkIOSWeb, checkWeb } from "@/util/apputil";
import { Button } from "antd";
import { checkEmpty } from "@/util/stringutil";
import Icon from "@/components/common/icon/icon";
import { isAndroid, isIOS } from "react-device-detect";
import { useTranslations } from "next-intl";
// import dynamic from "next/dynamic";
// const Data = dynamic(() => import("@/components/layout/data/data"), { ssr: false });
// const List = dynamic(() => import("@/components/layout/data/list/list"), { ssr: false });
const appStoreURL = !checkEmpty(appAppleId) ? "https://apps.apple.com/app/" + appAppleId : "";

export default function DataList(params: DataListParams) {
  const t = useTranslations("contents");

  // const router = useRouter();
  const searchParams = useSearchParams();
  const urlpathname = params.pathname ?? usePathname();
  const [articleParam, setArticleParam] = useState(urlpathname.split("/").length);
  const [pathname, setPathname] = useState<string | undefined>(urlpathname);
  const getDataId = (param: string | number): string | undefined => {
    if (typeof param === "string") {
      return searchParams?.get(param) ?? undefined;
    } else if (typeof param == "number") {
      const path_split = (window.location.pathname ?? pathname ?? "").split("/");
      return path_split.length >= param ? path_split[param] : undefined;
    } else {
      return undefined;
    }
  };

  const [dataId, setDataId] = useState(getDataId(articleParam) ?? "");
  const [dataMode, setDataMode] = useState((searchParams?.get("mode") ?? dataId == "write") ? "write" : (params.defaultMode ?? "view"));
  const [hiddenAds, setHiddenAds] = useState(typeof params.hiddenAds === "boolean" ? params.hiddenAds : false);
  const [listTimer, setListTimer] = useState(params.timer);

  //Debug(dataId, dataMode);

  const changeDataId = (id: string, useDefaultId?: boolean, mode?: string, modeField?: string, historyPush?: boolean) => {
    //Debug(id);
    const searchCols =
      params.writeMatching && params.dataFunction && params.dataFunction["getSearchCols"]
        ? (params.dataFunction["getSearchCols"]() as DataColumn[] | undefined)
            ?.filter((item) => item.inputType !== "element")
            .map((item) => item.field)
        : undefined;
    const removeFields = params.writeMatching
      ? Object.keys(params.writeMatching).filter((key) => {
          return searchCols ? !searchCols?.includes(key) : true;
        })
      : undefined;
    Debug("changeDataId : ", searchCols, params.writeMatching, removeFields);
    commonChangeDataId(setDataId, setDataMode, pathname ?? "", dataId, id, useDefaultId, mode, modeField, removeFields, historyPush);
  };

  const [codeGroups, setCodeGroups] = useState<Record<string, any[]> | undefined | null>(null);
  const [groupList, setGroupList] = useState<string[]>([]);

  if (params.dataFunction) {
    params.dataFunction["setHiddenAds"] = (set: boolean) => {
      // Debug("setHiddenAds", set);
      if (hiddenAds !== set) {
      }
      setHiddenAds(set);
    };
  }

  useEffect(() => {
    const check_ads = typeof params.hiddenAds === "boolean" ? params.hiddenAds : false;
    // Debug("datalist params.hiddenAds", check_ads);
    setHiddenAds(check_ads);
  }, [params.hiddenAds]);

  useEffect(() => {
    if (window && !hiddenAds) {
      try {
        (window as any).adsbygoogle = (window as any).adsbygoogle || [];
        (window as any).adsbygoogle.push({});
      } catch (e) {
        Debug("AdSense Error:", e);
      }
    }
  }, [hiddenAds]);

  // useEffect(() => {
  // }, [params.locale, params.listCols, params.dataCols, params.listSearch, groupList]);

  useEffect(() => {
    const list_groups = getColsGroups(params.listCols);
    const list_search = getColsGroups(params.listSearch);
    const list_desccodes: DataCols = {};

    const listColdescs = params.listColDesc ? (params.listColDesc instanceof Array ? params.listColDesc : [params.listColDesc]) : [];
    listColdescs.forEach((listColdesc) => {
      const col = typeof listColdesc === "string" ? { field: listColdesc } : listColdesc;
      list_desccodes[col.field] = col;
    });

    const list_desc = getColsGroups(list_desccodes);

    const data_groups = getColsGroups(params.dataCols);
    const merge = mergeArr(list_groups, list_search, list_desc, data_groups);

    Debug("check loading groups in datalist", merge, groupList, params.locale, params.listCols, params.dataCols, params.listSearch);
    if (merge) {
      if (
        groupList === undefined ||
        merge.length !== groupList.length ||
        merge.some((item) => !groupList.includes(item)) ||
        params.pathname !== pathname
      ) {
        Debug("change groups in datalist");
        //setLoadingCode(true);
        setGroupList(merge);
        getCodeGroups(merge, params.locale, setCodeGroups);
        // } else {
        //   Debug("not change groups");
      }
      //setCodeGroups(null);
    } else {
      setCodeGroups({});
    }

    const temp_articleParam = (params?.pathname ?? "").split("/").length;
    const DataId = getDataId(temp_articleParam) ?? "";
    const temp_searchParams = new URLSearchParams(window.location.search);
    const DataMode = (temp_searchParams.get("mode") ?? DataId === "write") ? "write" : (params.defaultMode ?? "view");
    Debug("getDataId : " + DataId, DataMode, params.page, params.pathname);

    if (dataId !== DataId || dataMode !== DataMode) {
      setDataId(DataId);
      setDataMode(DataMode);
      if (articleParam !== temp_articleParam) {
        setArticleParam(temp_articleParam);
      }
    }

    if (params.pathname !== pathname) {
      if (params.pathname !== pathname) {
        if (params.setTimer && listTimer) {
          params.setTimer({ timer: listTimer, start: undefined });
        }
        setPathname(params?.pathname);
        setListTimer(params.timer);
      }
    }
    // checkCodeGroupList(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.pathname, params.locale, params.listCols, params.dataCols, params.listSearch, params.listColDesc, groupList]);

  const datapop = (e: any) => {
    Debug("DataList popstate datapop : start", params.pathname, pathname);
    if (params.pathname === pathname) {
      const temp_articleParam = (params?.pathname ?? "").split("/").length;
      const DataId = getDataId(temp_articleParam) ?? "";
      const temp_searchParams = new URLSearchParams(window.location.search);
      const DataMode = (temp_searchParams.get("mode") ?? DataId === "write") ? "write" : (params.defaultMode ?? "view");
      Debug("DataList popstate datapop : ", params.pathname + "," + pathname, dataMode + "," + DataMode + " - " + dataId + "," + DataId);
      if (dataId !== DataId || dataMode !== DataMode || checkEmpty(DataId)) {
        Debug("DataList popstate datapop : change data id");
        setDataId(DataId);
      }
      Debug("DataList popstate datapop : change Data Mode");
      setDataMode(DataMode);
    }
  };

  useEffect(() => {
    window.addEventListener("popstate", datapop);
    return () => {
      if (params.setTimer && params.timer) {
        params.setTimer({ timer: params.timer, start: undefined });
      }
      window.removeEventListener("popstate", datapop);
    };
  }, []);

  //Debug(params);
  return (
    <Container className={cn(params.className ?? "", "flex-col", "max-w-full")}>
      {hiddenAds ? (
        ""
      ) : (
        <>
          <Head>
            <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js" crossOrigin="anonymous" />
            <script
              dangerouslySetInnerHTML={{
                __html: `
                (adsbygoogle = window.adsbygoogle || []).push({
                  google_ad_client: "ca-pub-3184031734391761",
                  enable_page_level_ads: true
                });
              `,
              }}
            />
          </Head>
          {checkDebug() ? <Flex className="hidden">광고표시</Flex> : ""}
        </>
      )}
      {checkAndroidWeb || checkIOSWeb || (checkWeb && !isIOS && !isAndroid) ? (
        <Flex className="justify-end mt-4">
          {checkAndroidWeb || (checkWeb && !isIOS) ? (
            <Button
              href={
                isAndroid
                  ? `intent://open#Intent;scheme=${appScheme};package=site.coffeein.app;end`
                  : `https://play.google.com/store/apps/details?id=site.coffeein.app`
              }
              target="_blank"
              type="primary"
              className="soft_button mr-2 min-w-[2rem]"
              icon={<Icon iconType="" iconName="GooglePlayLogo" weight="bold" />}
            >
              {t("play_store_link")}
            </Button>
          ) : (
            ""
          )}
          {(checkIOSWeb || (checkWeb && !isAndroid)) && !checkEmpty(appStoreURL) ? (
            <Button
              href={isIOS ? "#" : appStoreURL}
              target={isIOS ? undefined : "_blank"}
              type="primary"
              className={cn("soft_button mr-2 min-w-[2rem]", checkWeb && !isIOS && !isAndroid ? "ml-2" : "")}
              icon={<Icon iconType="" iconName="AppleLogo" weight="bold" />}
              onClick={
                isIOS
                  ? (e) => {
                      e.preventDefault();
                      const appSchemeUrl = `${appScheme}://open`; // 앱에서 처리할 custom url
                      const now = Date.now();
                      window.location.href = appSchemeUrl;
                      setTimeout(() => {
                        if (Date.now() - now < 1500) {
                          if (!checkEmpty(appStoreURL)) {
                            window.location.href = appStoreURL;
                          }
                        }
                      }, 1000);
                    }
                  : undefined
              }
            >
              {t("app_store_link")}
            </Button>
          ) : (
            ""
          )}
        </Flex>
      ) : (
        ""
      )}

      {/* {authSelect ? (
        <Container className={cn(params.authClassName ?? dv.dataClassName)}>
          <Form>{authSelect}</Form>
        </Container>
      ) : (
        ""
      )} */}

      {(params.pageAuth?.view ?? true) ? (
        <Data
          articleParam={articleParam}
          dataId={dataId}
          dataMode={dataMode}
          changeDataId={changeDataId}
          codeGroups={codeGroups ?? {}}
          useDatalist={true}
          {...params.dataFetch}
          {...params}
        />
      ) : (
        ""
      )}
      {(params.useList ?? true) && params.listFetch ? (
        <List
          listMode={dataMode}
          listColLink={params.listLink ?? changeDataId}
          dataId={dataId}
          codeGroups={codeGroups ?? {}}
          {...params.listFetch}
          {...params}
        />
      ) : (
        ""
      )}
    </Container>
  );
}
